export enum childTypes {
	Table = "Tabella",
	Group = "Gruppo"
}